export class DocumentUpload {
    module: string;
    fileName: string;
    contentType: string;
}